class ReviewBundleItems extends HTMLElement {
  constructor() {
    super();

    
  }

  connectedCallback() {
    this.renderBundleItems();
  }

  renderBundleItems() {
    const numberOfMealsPerMenu = Number(document.querySelector('.review-order').dataset.numberOfMealsPerMenu);
    const totalNumberOfMeals = Number(document.querySelector('.review-order').dataset.totalNumberOfMeals);

    let menuHTML = ``;
    Object.keys(window.bundleBasket).forEach((menu) => {
      const menuNumberSelectedMeals = window.bundleHelpers.menuSelectedMealsCount(menu);
      const isMenuCompleted = menuNumberSelectedMeals === numberOfMealsPerMenu;
      menuHTML += `<div class="review-summary__item"> <div class="review-summary__item-title">Your ${menu} </div> </div>`;
      Object.values(window.bundleBasket[menu]).forEach((meal, index) => {
        menuHTML += this.getMealHTML(meal, menu, isMenuCompleted, index);
      });
    });

    this.innerHTML = menuHTML;
  }

  getMealHTML(meal, menu, isMenuCompleted, index) {
    return `<div class="review-summary__item">
      <div class="review-summary__item-info">
        <img
          class="review-summary__item-image"
          src="${meal.image}"
          alt="${meal.title}"
          loading="lazy"
          width="90"
          height="90"
        >
        <div class="review-summary__item-title">${meal.title}</div>
      </div>
      <div class="review-summary__item-quantity">
        ${meal.quantity}
      </div>
    </div>`
  }
}
customElements.define('review-bundle-items', ReviewBundleItems);